module.exports = __webpack_public_path__ + "0d48b5bf9b4735b138a37d3339f706fe.houses.svg";